import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayPropertyToStringList',
    standalone: false
})
export class ArrayPropertyToStringListPipe implements PipeTransform {

    static format(list: any[], property: string, separator: string = ', '): string {
        return (list||[]).map(e => e[property]).join(separator) ;
    }

    transform(list: any[], property: string, separator: string = ', '): string {
        return ArrayPropertyToStringListPipe.format(list, property, separator);
    }

}
